/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getListBlocks.defs.js'
export { main as default } from './getListBlocks.defs.js'
